import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import DoublePagePdf from '@monorepo/shared/src/components/common/Pdf/DoublePagePdf';
import type { Book } from '@monorepo/shared/src/graph/schema-generated-types-student';

type Props = {
  book: Book;
  pages: any;
  scale?: number;
};

const PageViewer: any = ({ book, pages, scale = 1.0 }: Props) => {
  const classes = useStyles({ book, scale });

  return (
    <Box className={classes.container}>
      <DoublePagePdf
        paperWrapper={false}
        leftPage={{
          documentProps: { file: book?.url },
          pageProps: {
            pageNumber: pages[0].pageNumber,
          },
        }}
        rightPage={{
          documentProps: { file: book?.url },
          pageProps: {
            pageNumber: pages[1].pageNumber,
          },
        }}
      />
    </Box>
  );
};

const useStyles = makeStyles(() => {
  return {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '12px 60px',
      overflow: 'hidden',
      height: '100%',
    },
  };
});

export default PageViewer;
